<template>
  <div v-if="items.length">
    <div class="lead-timeline-info" v-if="items.length > 1">
      <div class="timeline-avtor">
        <div class="lead-timeline-action timeline-home">Updates by</div>
        <div class="lead-timeline-employee">{{ item.user_name }}:</div>
      </div>
      <div class="timline-date">{{ item['date&time'] }}</div>
    </div>
    <div class="lead-timeline__item" v-for="el in items" v-if="el.update_type !== 'create'">
      <div class="timeline__item_text" v-if="el.update_type === 'leadstatus'">
        <span class="acth-type">{{el.update_type.toLowerCase()}} by:</span>
        <div class="status-updated-wrapper">
          <div class="lead-info-status td--salestatus">
            <div class="ui-ddbox ui-ddbox-select c-1" data-table="" data-id="" data-leadid=""
                 data-task="salestatus">
              <button class="ui-ddbtn">
                <span class="ui-ddbtnvalue">{{ el.old_value }}</span>
                <i class="fa fa-caret-down" aria-hidden="true"></i></button>
              <div class="ui-ddbody">
                <div class="ui-ddsection ui-salestatusList">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="status-updated__item status-updated-arrow">-&gt;</div>
          <div class="lead-info-status td--salestatus">
            <div class="ui-ddbox ui-ddbox-select c-1" data-table="" data-id="" data-leadid=""
                 data-task="salestatus">
              <button class="ui-ddbtn"><span class="ui-ddbtnvalue">{{ el.new_value }}</span>
                <i class="fa fa-caret-down" aria-hidden="true"></i>
              </button>
              <div class="ui-ddbody">
                <div class="ui-ddsection ui-salestatusList">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="timeline__item_text" v-if="el.update_type === 'assign'">
        <span class="acth-type">{{ el.update_type.toLowerCase() }} by:</span>
        <span>{{ el.old_value }}</span><span>-&gt;</span><span>{{ el.new_value }}</span>
      </div>
    </div>
    <div class="lead-timeline-info" v-if="item.update_type === 'create'">
      <div class="timeline-avtor">
        <div class="lead-timeline-action timeline-lead-created">Lead was created</div>
      </div>
      <div class="timline-date">{{ item['date&time'] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdatesType",
  props: {
    items: Array
  },
  data() {
    return {
      item: this.items[0] ?? {}
    }
  }
}
</script>

<style scoped>

</style>
